module.exports = __webpack_public_path__ + "img/nav_bg_3.9192ba4.png";